import { CategorySortField, SortOrder } from '../types/category';

// Pagination options for category list
export const CATEGORY_PAGE_SIZES = [20, 50, 100];
export const CATEGORY_DEFAULT_PAGE_SIZE = 20;

// Default pagination settings for categories
export const CATEGORY_PAGINATION_DEFAULT = {
  currentPage: 1,
  pageSize: CATEGORY_DEFAULT_PAGE_SIZE,
  sortBy: 'gmtModified' as CategorySortField,
  sortOrder: 'desc' as SortOrder,
};

// Table column widths for category table
export const CATEGORY_COLUMN_WIDTHS = {
  ID: 80,
  DIVISION_CODE: 120,
  DIVISION_NAME: 120,
  GROUP_CODE: 120,
  GROUP_NAME: 120,
  DEPARTMENT_CODE: 120,
  DEPARTMENT_NAME: 120,
  CLASS_CODE: 120,
  CLASS_NAME: 120,
  SUBCLASS_CODE: 120,
  SUBCLASS_NAME: 120,
  CREATOR_NAME: 100,
  GMT_CREATE: 180,
  GMT_MODIFIED: 180,
  ACTIONS: 120,
};

// Search placeholder texts - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_SEARCH_PLACEHOLDERS = {
//   DIVISION_CODE: '请输入事业部编码',
//   DIVISION_NAME: '请输入事业部名称',
//   GROUP_CODE: '请输入组编码',
//   GROUP_NAME: '请输入组名称',
//   DEPARTMENT_CODE: '请输入部门编码',
//   DEPARTMENT_NAME: '请输入部门名称',
//   CLASS_CODE: '请输入类别编码',
//   CLASS_NAME: '请输入类别名称',
//   SUBCLASS_CODE: '请输入子类别编码',
//   SUBCLASS_NAME: '请输入子类别名称',
//   SEARCH: '请输入关键词搜索',
// };

// Form field labels - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_FORM_LABELS = {
//   ID: 'ID',
//   DIVISION_CODE: '事业部编码',
//   DIVISION_NAME: '事业部名称',
//   GROUP_CODE: '组编码',
//   GROUP_NAME: '组名称',
//   DEPARTMENT_CODE: '部门编码',
//   DEPARTMENT_NAME: '部门名称',
//   CLASS_CODE: '类别编码',
//   CLASS_NAME: '类别名称',
//   SUBCLASS_CODE: '子类别编码',
//   SUBCLASS_NAME: '子类别名称',
//   CREATOR_ACCOUNT: '创建人账号',
//   CREATOR_NAME: '创建人姓名',
//   GMT_CREATE: '创建时间',
//   MODIFIER_ACCOUNT: '修改人账号',
//   MODIFIER_NAME: '修改人姓名',
//   GMT_MODIFIED: '修改时间',
//   DELETED: '删除状态',
// };

// Table column titles - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_TABLE_COLUMNS = {
//   ID: 'ID',
//   DIVISION_CODE: '事业部编码',
//   DIVISION_NAME: '事业部',
//   GROUP_CODE: '组编码',
//   GROUP_NAME: '组',
//   DEPARTMENT_CODE: '部门编码',
//   DEPARTMENT_NAME: '部门',
//   CLASS_CODE: '类别编码',
//   CLASS_NAME: '类别',
//   SUBCLASS_CODE: '子类别编码',
//   SUBCLASS_NAME: '子类别',
//   CREATOR_NAME: '创建人',
//   GMT_CREATE: '创建时间',
//   GMT_MODIFIED: '修改时间',
//   ACTIONS: '操作',
// };

// Action button texts - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_ACTION_TEXTS = {
//   VIEW: '查看',
//   SEARCH: '搜索',
//   RESET: '重置',
//   REFRESH: '刷新',
//   EXPORT: '导出',
//   BACK: '返回',
// };

// Success messages - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_MESSAGES = {
//   FETCH_SUCCESS: '类目数据获取成功',
//   FETCH_ERROR: '获取类目数据失败',
//   NO_DATA: '暂无数据',
//   NETWORK_ERROR: '网络连接异常，请检查网络后重试',
//   SERVER_ERROR: '系统繁忙，请稍后再试',
//   PERMISSION_ERROR: '您没有权限访问此功能，请联系管理员',
// };

// Empty state messages - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_EMPTY_MESSAGES = {
//   NO_CATEGORIES: '暂无类目数据',
//   NO_SEARCH_RESULTS: '未找到符合条件的类目',
// };

// Loading messages - 这些应该在组件中使用 t() 函数获取，而不是在这里定义常量
// export const CATEGORY_LOADING_MESSAGES = {
//   FETCHING: '正在获取类目数据...',
//   SEARCHING: '正在搜索...',
// };

// Validation rules
export const CATEGORY_VALIDATION_RULES = {
  divisionCode: {
    max: 100,
    message: '事业部编码长度不能超过100个字符',
  },
  divisionName: {
    max: 100,
    message: '事业部名称长度不能超过100个字符',
  },
  groupCode: {
    max: 100,
    message: '组编码长度不能超过100个字符',
  },
  groupName: {
    max: 100,
    message: '组名称长度不能超过100个字符',
  },
  departmentCode: {
    max: 100,
    message: '部门编码长度不能超过100个字符',
  },
  departmentName: {
    max: 100,
    message: '部门名称长度不能超过100个字符',
  },
  classCode: {
    max: 100,
    message: '类别编码长度不能超过100个字符',
  },
  className: {
    max: 100,
    message: '类别名称长度不能超过100个字符',
  },
  subClassCode: {
    max: 100,
    message: '子类别编码长度不能超过100个字符',
  },
  subclassName: {
    max: 100,
    message: '子类别名称长度不能超过100个字符',
  },
};